"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Component_1 = __importDefault(require("../Component"));
class PlaylistButtonComponent extends Component_1.default {
    constructor(imageSrc, title) {
        super();
        this.imageSrc = imageSrc;
        this.title = title;
    }
    getTemplate() {
        return `
      <li class="playlist__item">
        <div class="playlist__image-container">
          <picture class="playlist__small-btn">
            <source srcset="${this.imageSrc}" media="(max-width: 576px)">
            <source srcset="${this.imageSrc}" media="(max-width: 1440px)">
            <img class="playlist__img playlist__button-img" src="${this.imageSrc}" alt="Любимые песни">
          </picture>
        </div>
        <div class="playlist__content">
          <h3 class="playlist__h3">
            <a class="playlist__h3__link" href="/">${this.title}</a>
          </h3>
        </div>
      </li>
    `;
    }
    addOnClickListener(onClickCallback) {
        const linkElement = this.getElement().querySelector('.playlist__h3__link');
        if (!linkElement) {
            throw new Error('Link element not found');
        }
        linkElement.addEventListener('click', onClickCallback);
    }
}
exports.default = PlaylistButtonComponent;
